export function cpmMultiplierFactor(cost) {
  return cost / 1000;
}
